module.exports = __webpack_public_path__ + "img/img4.180ddc1c.png";